import React, { useState } from 'react';
import { useTheme } from '../ThemeContext';
import { useToast } from './Toast';
import { agentPost } from '../utils/functionAuth';
import { DELETE_PHRASE } from '../shared/homeownerAccount';

function AgentAccountDelete({ onDeleted }) {
  const { colors } = useTheme();
  const { showToast } = useToast();
  const [confirming, setConfirming] = useState(false);
  const [phrase, setPhrase] = useState('');
  const [busy, setBusy] = useState(false);

  const removeAccount = async () => {
    if (phrase !== DELETE_PHRASE || busy) return;
    setBusy(true);
    try {
      const result = await agentPost('/.netlify/functions/agent-account', {
        action: 'delete',
        confirm: DELETE_PHRASE,
      });
      if (!result.ok) {
        showToast(result.error || 'Could not delete your account.', 'error');
        setBusy(false);
        return;
      }
      showToast('Your account has been deleted.', 'success');
      if (onDeleted) await onDeleted('deleted');
    } catch (error) {
      showToast(error.message || 'Could not delete your account.', 'error');
      setBusy(false);
    }
  };

  return (
    <div style={{ marginTop: '1.5rem', paddingTop: '1.5rem', borderTop: `1px solid ${colors.border}` }}>
      <h4 style={{ fontSize: '1.05rem', fontWeight: 600, color: colors.text, margin: '0 0 0.5rem' }}>
        Delete Account & Data
      </h4>
      {!confirming ? (
        <>
          <p style={{ fontSize: '0.9rem', color: colors.textSecondary, marginBottom: '0.75rem' }}>
            This permanently deletes your Pacarion agent account. If you own a team that still has other agents, remove them first.
          </p>
          <button
            type="button"
            onClick={() => setConfirming(true)}
            style={{
              minHeight: '48px',
              padding: '0.75rem 1rem',
              borderRadius: '0.75rem',
              border: `1px solid ${colors.border}`,
              background: 'transparent',
              color: '#b42318',
              fontWeight: 650,
              cursor: 'pointer',
            }}
          >
            Delete my account
          </button>
        </>
      ) : (
        <div>
          <p style={{ margin: '0 0 0.75rem', color: colors.text, lineHeight: 1.45 }}>
            This permanently deletes your agent account. It cannot be undone. A team you own is deleted with you only when you are the last agent on it, and an active subscription is cancelled.
          </p>
          <p style={{ margin: '0 0 0.75rem', color: colors.text, lineHeight: 1.45 }}>
            Your homeowners will keep their own accounts and their data. They will not be emailed. If you are the only agent, they are detached from you. If you belong to a team, they move to your team owner.
          </p>
          <label htmlFor="delete-agent-account" style={{ display: 'block', marginBottom: '0.35rem', color: colors.textSecondary, fontSize: '0.9rem' }}>
            Type DELETE to delete this account
          </label>
          <input
            id="delete-agent-account"
            value={phrase}
            onChange={(event) => setPhrase(event.target.value)}
            autoComplete="off"
            autoCapitalize="characters"
            style={{
              width: '100%',
              boxSizing: 'border-box',
              padding: '0.75rem',
              borderRadius: '0.75rem',
              border: `1px solid ${colors.border}`,
              background: colors.surfaceAlt || colors.surface,
              color: colors.text,
              fontSize: '1rem',
              marginBottom: '0.75rem',
            }}
          />
          <div style={{ display: 'flex', gap: '0.75rem', flexWrap: 'wrap' }}>
            <button
              type="button"
              onClick={removeAccount}
              disabled={busy || phrase !== DELETE_PHRASE}
              style={{
                flex: '1 1 140px',
                minHeight: '48px',
                border: 'none',
                borderRadius: '0.75rem',
                background: phrase === DELETE_PHRASE ? '#b42318' : colors.border,
                color: 'white',
                fontWeight: 650,
                cursor: phrase === DELETE_PHRASE && !busy ? 'pointer' : 'default',
              }}
            >
              {busy ? 'Deleting…' : 'Delete my account'}
            </button>
            <button
              type="button"
              onClick={() => {
                setConfirming(false);
                setPhrase('');
              }}
              disabled={busy}
              style={{
                flex: '1 1 120px',
                minHeight: '48px',
                borderRadius: '0.75rem',
                border: `1px solid ${colors.border}`,
                background: 'transparent',
                color: colors.text,
                fontWeight: 600,
                cursor: 'pointer',
              }}
            >
              Cancel
            </button>
          </div>
        </div>
      )}
      <p style={{ fontSize: '0.9rem', color: colors.textSecondary, margin: '0.75rem 0 0' }}>
        support@pacarion.com
      </p>
    </div>
  );
}

export default AgentAccountDelete;
